import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getLivestreamEventInfoFromDiscoverGroupItemContent } from './DiscoverLivestreamEventItem';
import styles from './HeroSliderItem.css';
import LivestreamEventImage from '../livestream-event/LivestreamEventImage';
import HeroSliderItemLink from './HeroSliderItemLink';
import CollectionButton from '../common/CollectionButton';
import { injectIntl, intlShape } from 'react-intl';
import * as livestreamActions from '../../actions/livestreamEvents';
import collectibleEntity, { collectibleEntityPropTypes } from '../../hoc/collectibleEntity';
import { ENTITY_TYPE_LIVESTREAM_EVENT } from '../../constants';
import { commonMessages } from '../messages/Common';

function LivestreamEventHeroSliderItem({
  isActive,
  url,
  item,
  onClick,
  isInCollection,
  toggleIsInCollection,
  loadLivestreamEvent,
  intl,
}) {
  const event = getLivestreamEventInfoFromDiscoverGroupItemContent(item.content);
  const { title, imageCredits, slug, isLive, isAvailable, isUpcoming } = event;

  const toggleInCollection = e => {
    e.preventDefault();
    // load event entity in the background and save it into the store
    loadLivestreamEvent(slug);
    toggleIsInCollection();
  };

  return (
    <div className={styles.eventSlideContent}>
      <HeroSliderItemLink
        onClick={onClick}
        isActive={isActive}
        url={url}
        title={intl.formatMessage(commonMessages.view, { title })}
      >
        <LivestreamEventImage event={event} isHeroItem>
          {imageCredits && (
            <figcaption className={styles.credits}>Photo: {imageCredits}</figcaption>
          )}
        </LivestreamEventImage>
      </HeroSliderItemLink>
      <div className={styles.description}>
        <HeroSliderItemLink onClick={onClick} isActive={isActive} url={url}>
          <div className={styles.eventTitleContainer}>
            <p className={styles.eventTitle}>{title}</p>
            <CollectionButton
              active={isInCollection}
              onClick={toggleInCollection}
              disabled={!isLive && !isAvailable && !isUpcoming}
            />
          </div>
        </HeroSliderItemLink>
      </div>
    </div>
  );
}

LivestreamEventHeroSliderItem.propTypes = {
  item: PropTypes.object.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,

  loadLivestreamEvent: PropTypes.func.isRequired,
  intl: intlShape.isRequired,

  ...collectibleEntityPropTypes,
};

function getCollectibleEntityDescription(props) {
  return {
    id: props.item.content.id,
    trackingSource: 'Livestream Event',
  };
}

export default compose(
  connect(null, {
    loadLivestreamEvent: livestreamActions.loadLivestreamEvent,
  }),
  collectibleEntity(ENTITY_TYPE_LIVESTREAM_EVENT, getCollectibleEntityDescription),
  injectIntl
)(LivestreamEventHeroSliderItem);
